import { render } from "./FormDesign.vue?vue&type=template&id=f98ad024"
import script from "./FormDesign.vue?vue&type=script&lang=js"
export * from "./FormDesign.vue?vue&type=script&lang=js"

import "./FormDesign.vue?vue&type=style&index=0&id=f98ad024&lang=css"
script.render = render

export default script